import React from 'react';
import { media, stylesheet } from 'typestyle';
import { Blue80, typeCompact14MediumProperties } from '@traceair/tds';
import { blueLinkStates } from '../../../../../styles/linkStates';

const css = stylesheet({
  link: {
    whiteSpace: 'nowrap',
    color: Blue80,
    marginLeft: 16,
    textDecoration: 'none',
    ...typeCompact14MediumProperties,
    ...blueLinkStates,
  },
  hideOnTinyScreen: {
    ...media(
      {
        maxWidth: 400,
      },
      {
        display: 'none',
      },
    ),
  },
});

export const MissionWindowGcpGuides = () => {
  return (
    <div>
      <a
        className={css.link}
        target="_blank"
        rel="noreferrer"
        href="https://sites.google.com/traceair.net/ta-fmp-tutorial"
      >
        <span className={css.hideOnTinyScreen}>Guides &&nbsp;</span>Resources
      </a>
    </div>
  );
};
